const env = Object.assign({}, process.env, window.env);

export const reCaptcha = {
  siteKey: env.VUE_APP_RECAPTCHA_SITE_KEY
};

export default { reCaptcha };
